import React from "react";
export default ({
  colors = [],
  selectedColor = null,
  setSelectedColor = () => {},
}) => {
  return (
    <div className="right-colors">
      {colors.map((color) => (
        <div
          className="color"
          key={color.id}
          style={{
            background: color.gradientString,
          }}
          onClick={() => setSelectedColor(color)}
        >
          {selectedColor?.id === color.id && (
            <span
              className="material-icons"
              style={{
                color: color.textColor,
              }}
            >
              check
            </span>
          )}
        </div>
      ))}
    </div>
  );
};
